// constants.js
export const splootsNFTAddress = "0x74b219d1805460B705f4f01C839a954a530B184D";
